// REMIX HMR BEGIN
if (!window.$RefreshReg$ || !window.$RefreshSig$ || !window.$RefreshRuntime$) {
  console.warn('remix:hmr: React Fast Refresh only works when the Remix compiler is running in development mode.');
} else {
  var prevRefreshReg = window.$RefreshReg$;
  var prevRefreshSig = window.$RefreshSig$;
  window.$RefreshReg$ = (type, id) => {
    window.$RefreshRuntime$.register(type, "\"app/components/ProfileImage.tsx\"" + id);
  }
  window.$RefreshSig$ = window.$RefreshRuntime$.createSignatureFunctionForTransform;
}
var _s = $RefreshSig$();
import * as __hmr__ from "remix:hmr";
if (import.meta) {
  import.meta.hot = __hmr__.createHotContext(
  //@ts-expect-error
  "app/components/ProfileImage.tsx");
  import.meta.hot.lastModified = "1748319561417.727";
}
// REMIX HMR END

import { useState } from 'react';
import { cn } from '~/utils/style';
const sizeClasses = {
  sm: 'w-8 h-8',
  md: 'w-12 h-12',
  lg: 'w-16 h-16',
  xl: 'w-24 h-24 sm:w-32 sm:h-32 md:w-40 md:h-40 lg:w-52 lg:h-52'
};
const textSizeClasses = {
  sm: 'text-sm',
  md: 'text-lg',
  lg: 'text-2xl',
  xl: 'text-4xl'
};
export function ProfileImage({
  src,
  alt,
  displayName,
  email,
  size = 'sm',
  className
}) {
  _s();
  const [imageError, setImageError] = useState(false);
  const [imageLoaded, setImageLoaded] = useState(false);

  // Generate initials from display name or email
  const initials = displayName?.charAt(0) || email?.charAt(0) || 'U';

  // Generate a fallback avatar URL that doesn't hit Google's servers
  const fallbackUrl = `https://ui-avatars.com/api/?name=${encodeURIComponent(displayName || email || 'User')}&background=random&color=fff`;
  const handleImageError = () => {
    setImageError(true);
  };
  const handleImageLoad = () => {
    setImageLoaded(true);
  };

  // If no source provided or image failed to load, show initials
  if (!src || imageError) {
    return <div className={cn(sizeClasses[size], 'rounded-full bg-gradient-to-r from-pink-400 to-fuchsia-500', 'flex items-center justify-center text-white font-semibold', textSizeClasses[size], className)}>
        {initials.toUpperCase()}
      </div>;
  }
  return <div className={cn('relative', sizeClasses[size], className)}>
      {/* Show placeholder while loading */}
      {!imageLoaded && <div className={cn('absolute inset-0 rounded-full bg-gradient-to-r from-pink-400 to-fuchsia-500', 'flex items-center justify-center text-white font-semibold animate-pulse', textSizeClasses[size])}>
          {initials.toUpperCase()}
        </div>}
      
      {/* Actual image */}
      <img src={src} alt={alt || displayName || 'Profile'} className={cn('w-full h-full rounded-full object-cover', !imageLoaded && 'opacity-0', 'transition-opacity duration-300')} onError={handleImageError} onLoad={handleImageLoad} referrerPolicy="no-referrer" crossOrigin="anonymous" />
    </div>;
}
_s(ProfileImage, "2jlic82j/UFgs85TNuY4TIFvRcw=");
_c = ProfileImage;
var _c;
$RefreshReg$(_c, "ProfileImage");

window.$RefreshReg$ = prevRefreshReg;
window.$RefreshSig$ = prevRefreshSig;